module.exports = __webpack_public_path__ + "img/logo.b944b79a.png";